var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1514189353878,
    className: "icon",
    style: {},
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1197,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.367 0h992.97v341.333H9.366z",
    fill: "#55C7F7",
    "p-id": 1198
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.367 341.333h992.97v341.334H9.366z",
    fill: "#F95F5D",
    "p-id": 1199
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.367 682.667h992.97V1024H9.366z",
    fill: "#7ECF3B",
    "p-id": 1200
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.7 0h310.303v1024H350.7z",
    fill: "#FDAF42",
    "p-id": 1201
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.154 386.638V646.05h403.394V386.638H304.154z m356.849 215.97H350.7V429.46h310.303v173.15z",
    fill: "#FFFFFF",
    "p-id": 1202
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.982c48675c38139800a2f45d7c86a661.svg";
export { ForwardRef as ReactComponent };